<ng-container *transloco="let convert;">
  <div class="back-link row">
    <div class="col">
      <a [routerLink]="backRouterLink"
        [state]="{ scrollPosition: scrollPosition }"
        id="btn-back"
        class="btn btn-link"
        data-track-elem="button"
        [attr.data-track-name]="backLinkText"
        [attr.aria-label]="backLinkText">
        <i class="me-1 allycon-glyph-chevron-left" aria-hidden="true"></i>
        <span class="backToPreviousPageText">{{backLinkText}}</span>
      </a>
    </div>
    @if (headerType == reportHeaderType.TABULAR) {
      <div class="col-6 preview-menu-buttons align-self-center text-center">
        <button
          [attr.aria-label]="convert('reports.reportHeader.arialableOAP')"
          class="bg-secondary tab preview-button border-right-none"
          data-track-elem="button"
          data-track-name="Authorization Report"
          type="button"
          [ngClass]="{active: isSelectedReportType(reportTypes.AUTHORIZATION)}"
          (click)="reportTypeChanged.emit(reportTypes.AUTHORIZATION)"
          >
          {{convert('reports.reportHeader.textAuthorization')}} <span class="mobile-hidden"> {{convert('reports.reportHeader.textReport')}} </span>
        </button>
        <button
          [attr.aria-label]="convert('reports.reportHeader.arialabelORS')"
          class="bg-secondary tab preview-button border-right-none"
          data-track-elem="button"
          data-track-name="Record of Sale"
          type="button"
          [ngClass]="{active: isSelectedReportType(reportTypes.RECORD_OF_SALE)}"
          (click)="reportTypeChanged.emit(reportTypes.RECORD_OF_SALE)"
          >
          {{convert('reports.reportHeader.textRecord')}} <span class="mobile-hidden"> {{convert('reports.reportHeader.textOfSale')}} </span>
        </button>
        <button
          [attr.aria-label]="convert('reports.reportHeader.arialabelOpenBoth')"
          class="bg-secondary tab preview-button"
          data-track-elem="button"
          data-track-name="Both"
          type="button"
          [ngClass]="{active: isSelectedReportType(reportTypes.BOTH)}"
          (click)="reportTypeChanged.emit(reportTypes.BOTH)"
          >
          {{convert('reports.reportHeader.textBoth')}}
        </button>
      </div>
    }
    <div class="col">
    </div>
  </div>
  @if (headerType == reportHeaderType.DROPDOWN) {
    <h2 class="fw-bold mt-2">{{ convert('reports.reportHeader.textViewReports') }}</h2>
    <div class="dropdown-header">
      <span class="fw-bold mt-2 me-1">{{ convert('reports.reportHeader.labelReports') }}</span>
      <app-multi-select-dropdown
        [placeholder]="getPlaceholderText()"
        [checkboxButtonGroup]="reportDropdownOptions"
        (checkboxChanged)="updateSelectedReports($event)"
        (analyticsOnCheckboxChanged)="analyticsOnSelectReport($event)"
        >
      </app-multi-select-dropdown>
      @if (this.selectedReportTypes.length > 0) {
        <div class="function-container">
          <button
            data-track-elem="button"
            data-track-name="Print"
            class="btn btn-primary"
            (click)="printPurchaseItems()"
            >
            {{ convert('reports.reportHeader.btnPrint') }}
          </button>
          <button
            data-track-elem="button"
            data-track-name="Email"
            class="btn btn-secondary"
            (click)="showEmailModal()"
            >
            {{ convert('reports.reportHeader.btnEmail') }}
          </button>
        </div>
      }
    </div>
  }

  <app-email-modal
    modalId="report-header-email-modal"
    [purchasedItems]=purchasedItemDto
    [reportList]=selectedReportTypes>
  </app-email-modal>
  <app-error-modal></app-error-modal>
</ng-container>
